module.exports = __webpack_public_path__ + "93e08f3c745e5c097992661abee1e34c.svg";